/* PreviewEditor.tsx generated by @compiled/babel-plugin v0.36.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

// The types PromptEditorType should mirror what is in the editor-ai-injected-editors package
// at `platform/packages/editor/editor-ai-injected-editors/src/editors/types.ts.

// The types PromptEditorProps and PromptEditor should mirror what is in the editor-ai-injected-editors package
// at `packages/editor/editor-ai-injected-editors/src/editors/prompt.tsx`.

export var PreviewEditor = function PreviewEditor(_ref) {
  var PromptEditor = _ref.PromptEditor,
    defaultValue = _ref.defaultValue,
    autoFocus = _ref.autoFocus,
    onADFChange = _ref.onADFChange;
  var componentId = useMemo(function () {
    return "preview-editor-".concat(uuidv4());
  }, []);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/design-system/prefer-primitives, jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      "data-testid": "ai-experience-preview-editor-wrapper"
    }, /*#__PURE__*/React.createElement(PromptEditor, {
      type: 'preview-editor',
      key: componentId,
      autoFocus: autoFocus,
      defaultValue: defaultValue,
      onADFChange: onADFChange,
      enableLinks: true
    }))
  );
};